import { useTranslation, Trans } from 'react-i18next'
import moment from 'moment'
import { Box, Text, Stack, Inline, Columns, Column } from '@machobear/design-system'
import useGetPlan from '@/hooks/use-get-plan'
import Table from './table'
import Skeleton from '../../Skeletons'
import { PlanType } from '../../../types'

type Props = {
  currentPlan: PlanType
}
const PlanProducts = ({ currentPlan }: Props) => {
  const { t, i18n } = useTranslation()
  const isEnglish = i18n.languages[0] === 'en'

  const plans: any = {
    'essentials-plan-monthly': t('l.menu.view.essentials_free.button', 'Essentials (Free)'),
    'growth-plan-monthly': t('b.auth.create.growth.label', 'Growth'),
    'growth-plan-annual': t('b.auth.create.growth.label', 'Growth'),
    'business-plan-annual': t('b.auth.create.business.label', 'Business'),
    'business-plan-monthly': t('b.auth.create.business.label', 'Business'),
    'business-plan-special': t('b.auth.create.enterprise.label', 'Enterprise'),
    'growth-plan-monthly-coupon-wbrothers': t('b.auth.create.growth.label', 'Growth')
  }
  const { isLoading, data: planInfo } = useGetPlan()
  const billingDate = moment(planInfo?.nextResetDate).format(isEnglish ? 'MMMM Do' : 'MMM Do')
  const planTitle = plans[currentPlan]

  return !isLoading ? (
    <Stack align="left" space="xsmall">
      <Box width="full" maxWidth="large">
        <Columns space="none" alignY="top" collapseBelow="tablet">
          <Column>
            <Text weight="medium" size="medium" tone="secondary" baseline={false}>
              {t('l.usage.credits.included_in_your_plan.title', 'Included in your plan')}
            </Text>
          </Column>
          <Column>
            <Inline align={{ mobile: 'left', desktop: 'right' }} space="none">
              <Text weight="regular" size="small" tone="secondary" baseline={false}>
                <Trans i18nKey="l.plan.credits_date.resets.text">
                  {{ planTitle }} Plan · Credits reset on {{ billingDate }}
                </Trans>
              </Text>
            </Inline>
          </Column>
        </Columns>
      </Box>
      <Box width="full" maxWidth="large">
        <Table currentPlan={currentPlan} />
      </Box>
    </Stack>
  ) : (
    <Skeleton id="plan-products" />
  )
}

export default PlanProducts
